export enum TermStatus {
  CurrentTerm = 1,
  FutureTerm = 2,
  PastTerm = 3,
}
